import { render, staticRenderFns } from "./VideoListAddNew.vue?vue&type=template&id=171db826&"
import script from "./VideoListAddNew.vue?vue&type=script&lang=js&"
export * from "./VideoListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./VideoListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports